import ChatPanelSearch from './ChatPanelSearch'

export default ChatPanelSearch
